module.exports = __webpack_public_path__ + "static/media/preloader.8e508b87.svg";